<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right lmr-page">
            <el-alert class="lmr-notice" type="info" :closable="false" show-icon
                title="本页仅为请假退餐登记，不联动订餐退订；只统计审批通过的请假，同一学生同一天同一餐次在汇总中只计一次。">
            </el-alert>

            <el-form :inline="true" size="small" class="lmr-filters" @submit.native.prevent>
                <el-form-item label="退餐日期">
                    <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd"
                         start-placeholder="开始日期" end-placeholder="结束日期"
                        :clearable="false" style="width: 250px"></el-date-picker>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="filters.name" placeholder="学生姓名" clearable style="width: 140px"
                        @keyup.enter.native="handleSearch"></el-input>
                </el-form-item>
                <el-form-item label="订单号">
                    <el-input v-model="filters.orderNo" placeholder="订单号" clearable style="width: 160px"
                        @keyup.enter.native="handleSearch"></el-input>
                </el-form-item>
                <el-form-item label="餐次">
                    <el-select v-model="filters.dinnerTimeId" style="width: 130px">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in dinnerTimeOptions" :key="item.Id" :label="item.DinnerName"
                            :value="item.Id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="来源">
                    <el-select v-model="filters.requestType" style="width: 110px">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="请假" value="stu_leave"></el-option>
                        <el-option label="代请假" value="agent_leave"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核状态">
                    <el-select v-model="filters.auditStatus" style="width: 110px">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="待审核" :value="0"></el-option>
                        <el-option label="已同意" :value="1"></el-option>
                        <el-option label="已拒绝" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="请假状态">
                    <el-select v-model="filters.effectiveStatus" style="width: 120px">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="审批中" :value="0"></el-option>
                        <el-option label="已通过" :value="1"></el-option>
                        <el-option label="已失效" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-download" :loading="exporting" @click="handleExport">导出</el-button>
                </el-form-item>
                <div class="lmr-stats">
                    退餐人数 <b>{{ summary.TotalPersonCount }}</b>
                    <span class="lmr-stats-sep"></span>
                    退餐次数 <b>{{ summary.TotalMealCount }}</b>
                </div>
            </el-form>

            <div class="lmr-tabs-wrap">
                <div v-if="activeTab === 'detail'" class="lmr-batch-actions">
                    <span class="lmr-selected-count">已选 {{ selectedRows.length }} 条</span>
                    <el-button size="mini" type="success" :disabled="selectedRows.length === 0"
                        @click="approveRows(selectedRows)">批量同意</el-button>
                    <el-button size="mini" type="danger" :disabled="selectedRows.length === 0"
                        @click="openReject(selectedRows)">批量拒绝</el-button>
                    <el-button size="mini" :disabled="selectedRows.length === 0"
                        @click="deleteRows(selectedRows)">批量删除</el-button>
                </div>
                <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                    <el-tab-pane label="退餐明细" name="detail">
                    <div class="tbl-scroll-host">
                    <el-table ref="detailTable" height="100%" :data="detailList" v-loading="detailLoading" border style="width: 100%"
                        class="custom-tbl" @selection-change="handleSelectionChange" @row-click="handleRowClick">
                        <el-table-column type="selection" width="45" align="center"></el-table-column>
                        <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
                        <el-table-column label="学生信息" min-width="110" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="lmr-primary-text">{{ scope.row.UserName }}</div>
                                <div class="lmr-sub-text">{{ scope.row.DepartmentName }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="退餐项目" min-width="110">
                            <template slot-scope="scope">
                                <div class="lmr-primary-text">{{ scope.row.MealDate }}</div>
                                <div class="lmr-sub-text">{{ scope.row.WeekDayName }} · {{ scope.row.DinnerName }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单号" min-width="130">
                            <template slot-scope="scope">
                                <div class="lmr-order-no" :title="scope.row.OrderNo || ''">
                                    <div class="lmr-primary-text">{{ orderNoLines(scope.row.OrderNo).first }}</div>
                                    <div v-if="orderNoLines(scope.row.OrderNo).second" class="lmr-sub-text">{{ orderNoLines(scope.row.OrderNo).second }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="请假信息" min-width="290">
                            <template slot-scope="scope">
                                <div class="lmr-leave-block"
                                    :title="'查看' + (scope.row.RequestTypeName || '请假') + '详情'"
                                    @click.stop="openLeaveDetail(scope.row)">
                                    <div class="lmr-status-line">
                                        <span class="lmr-status-label">类型</span>
                                        <span class="lmr-status-value">
                                            <span class="lmr-leave-link">{{ scope.row.RequestTypeName || '-' }}</span>
                                            <span> · {{ scope.row.LeaveTypeName || '-' }}</span>
                                        </span>
                                    </div>
                                    <div class="lmr-status-line">
                                        <span class="lmr-status-label">时间</span>
                                        <span class="lmr-status-value">{{ scope.row.LeaveStartDate || '-' }} ~ {{ scope.row.LeaveEndDate || '-' }}</span>
                                    </div>
                                    <div class="lmr-status-line">
                                        <span class="lmr-status-label">请假</span>
                                        <el-tag size="mini" :type="leaveStatusTagType(scope.row)">
                                            {{ leaveStatusLabel(scope.row) }}
                                        </el-tag>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="退餐审核" min-width="205">
                            <template slot-scope="scope">
                                <div class="lmr-status-line">
                                    <span class="lmr-status-label lmr-audit-status-label">状态</span>
                                    <el-tag size="mini" :type="auditTagType(scope.row)">
                                        {{ auditStatusLabel(scope.row) }}
                                    </el-tag>
                                </div>
                                <div class="lmr-status-line lmr-result-text">
                                    <span class="lmr-status-label lmr-audit-status-label">请假审批</span>
                                    <span class="lmr-status-value">{{ scope.row.EffectiveTime || '-' }}</span>
                                </div>
                                <div class="lmr-status-line lmr-result-text">
                                    <span class="lmr-status-label lmr-audit-status-label">退餐审核</span>
                                    <span class="lmr-status-value">{{ scope.row.AuditTime || '-' }}</span>
                                </div>
                                <div v-if="scope.row.InvalidReason || scope.row.AuditRejectReason"
                                    class="lmr-status-line lmr-result-text lmr-reason-text">
                                    <span class="lmr-status-label lmr-audit-status-label">{{ scope.row.InvalidReason ? '失效原因' : '拒绝原因' }}</span>
                                    <span class="lmr-status-value">{{ scope.row.InvalidReason || scope.row.AuditRejectReason }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="188" fixed="right" align="center">
                            <template slot-scope="scope">
                                <el-button type="success" size="mini" :disabled="!canAudit(scope.row)"
                                    @click="approveRows([scope.row])">同意</el-button>
                                <el-button type="danger" size="mini" :disabled="!canAudit(scope.row)"
                                    @click="openReject([scope.row])">拒绝</el-button>
                                <el-button type="info" size="mini" plain
                                    @click.stop="deleteRows([scope.row])">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>
                    <div class="pagination-container">
                        <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
                            :current-page="page" :page-size="pageSize" :page-sizes="[20, 50, 100, 200]" :total="total"
                            layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                    </div>
                    </el-tab-pane>

                    <el-tab-pane label="退餐汇总" name="summary">
                    <div class="lmr-summary-bar">
                        <el-radio-group v-model="summaryMode" size="small" @change="summaryPage = 1">
                            <el-radio-button label="day">按日期汇总</el-radio-button>
                            <el-radio-button label="class">按班级汇总</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="tbl-scroll-host">
                        <el-table :key="summaryMode" height="100%" :data="summaryPagedRows" v-loading="summaryLoading"
                            border style="width: 100%" class="custom-tbl" show-summary :summary-method="summaryMethod">
                            <el-table-column v-if="summaryMode === 'day'" label="日期" min-width="160">
                                <template slot-scope="scope">{{ scope.row.MealDate }} {{ scope.row.WeekDayName }}</template>
                            </el-table-column>
                            <el-table-column v-else prop="DepartmentName" label="班级" min-width="160" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="DinnerName" label="餐次" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="PersonCount" label="退餐人数" min-width="120" align="center">
                                <template slot-scope="scope">
                                    <a href="javascript:;" class="lmr-summary-link" title="查看明细"
                                        @click.stop="openSummaryDetail(scope.row)">{{ scope.row.PersonCount }}</a>
                                </template>
                            </el-table-column>
                            <el-table-column prop="MealCount" label="退餐次数" min-width="120" align="center">
                                <template slot-scope="scope">
                                    <a href="javascript:;" class="lmr-summary-link" title="查看明细"
                                        @click.stop="openSummaryDetail(scope.row)">{{ scope.row.MealCount }}</a>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pagination-container">
                        <el-pagination @current-change="val => summaryPage = val"
                            @size-change="val => { summaryPageSize = val; summaryPage = 1; }"
                            :current-page="summaryPage" :page-size="summaryPageSize" :page-sizes="[20, 50, 100, 200]"
                            :total="summaryRows.length" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                    </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </section>

        <!-- 审批流程弹窗：与请假报表/代请假报表同款样式。创建于 2026-10-26 -->
        <el-dialog title="审批流程" :visible.sync="leaveDetailVisible" width="640px"
            custom-class="approval-flow-dialog" @closed="resetLeaveDetail">
            <div v-loading="leaveDetailLoading">
                <el-tabs v-if="leaveDetailIsAgent" v-model="leaveDetailActiveTab" type="card">
                    <el-tab-pane label="请假明细" name="details">
                        <div class="detail-section">
                            <el-table :data="agentLeaveDetails" size="mini" border style="width: 100%; margin-top: 10px;" max-height="500px">
                                <el-table-column label="请假日期" width="">
                                    <template slot-scope="scope">{{ formatLeaveDay(scope.row.LeaveDate) }}</template>
                                </el-table-column>
                                <el-table-column label="时间段" min-width="">
                                    <template slot-scope="scope">{{ scope.row.StartTime }} - {{ scope.row.EndTime }}</template>
                                </el-table-column>
                                <el-table-column label="返校" width="" align="center">
                                    <template slot-scope="scope">
                                        <el-tag :type="scope.row.IsReturnSchool ? 'success' : 'info'" size="mini">
                                            {{ scope.row.IsReturnSchool ? '是' : '否' }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="TbThirdPartId" label="天波ID" width="120" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.TbThirdPartId > 0 ? scope.row.TbThirdPartId : '—' }}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="审批进度" name="steps">
                        <div class="flow-panel" style="margin-top: 8px;">
                            <div class="flow-panel-head">
                                <div class="flow-panel-title">
                                    <i class="el-icon-s-check"></i>
                                    <span>审批进度</span>
                                    <span v-if="approvalCreateTime" class="flow-create-time">创建时间：{{ approvalCreateTime }}</span>
                                </div>
                                <span v-if="approvalSteps.length" class="flow-count">{{ approvalSteps.length }} 人</span>
                            </div>
                            <div v-if="approvalSteps.length > 0" class="approval-steps-grid">
                                <div v-for="step in approvalSteps" :key="step.Id" class="approval-step-card"
                                    :class="['step-tone-' + (((step.StepNumber || 1) - 1) % 4), 'is-' + (step.Status || 'Pending')]">
                                    <div class="step-card-head">
                                        <div class="step-card-main">
                                            <span class="step-badge">步骤 {{ step.StepNumber }}</span>
                                            <span class="step-name">{{ step.ApproverName || '-' }}</span>
                                        </div>
                                        <el-tag size="mini" :type="getApprovalStepStatusType(step.Status)" effect="plain">
                                            {{ getApprovalStepStatusText(step.Status) }}
                                        </el-tag>
                                    </div>
                                    <div class="step-card-time">审批时间：{{ formatLeaveDateTimeFull(step.ApprovedAt) }}</div>
                                    <div v-if="step.Comments" class="step-card-comment">审批意见：{{ step.Comments }}</div>
                                </div>
                            </div>
                            <div v-else class="no-data no-data-compact">暂无审批流程记录</div>
                        </div>
                        <div class="flow-panel">
                            <div class="flow-panel-head">
                                <div class="flow-panel-title">
                                    <i class="el-icon-message"></i>
                                    <span>抄送与通知</span>
                                    <el-tag v-if="ccFromCurrentConfig" size="mini" type="warning" effect="plain">当前配置 · 仅供参考</el-tag>
                                    <el-tag v-else size="mini" type="success" effect="plain">提交快照</el-tag>
                                </div>
                                <span v-if="ccPersonList.length" class="flow-count">{{ ccPersonList.length }} 人</span>
                            </div>
                            <div class="cc-panel-block">
                                <div class="cc-block-label">指定人员</div>
                                <div v-if="ccPersonList.length" class="cc-people">
                                    <span v-for="(name, index) in ccPersonList" :key="index" class="cc-person-chip" :title="name">
                                        <i class="el-icon-user"></i>{{ name }}
                                    </span>
                                </div>
                                <div v-else class="cc-empty">未指定抄送人员</div>
                            </div>
                            <div class="cc-flags">
                                <div class="cc-flag" :class="ccClassTeacher ? 'is-on' : 'is-off'">
                                    <span class="cc-flag-dot"></span>
                                    <div class="cc-flag-text">
                                        <div class="cc-flag-name">抄送班主任</div>
                                        <div class="cc-flag-val">{{ ccClassTeacher ? '已开启' : '未开启' }}</div>
                                    </div>
                                </div>
                                <div class="cc-flag" :class="notifyParent ? 'is-on' : 'is-off'">
                                    <span class="cc-flag-dot"></span>
                                    <div class="cc-flag-text">
                                        <div class="cc-flag-name">通知家长</div>
                                        <div class="cc-flag-val">{{ notifyParent ? '已开启' : '未开启' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="ccFromCurrentConfig" class="cc-note">
                                无提交快照时，以上按学生当前匹配的流程配置展示，仅供参考
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>

                <div v-else>
                    <div class="flow-panel">
                        <div class="flow-panel-head">
                            <div class="flow-panel-title">
                                <i class="el-icon-s-check"></i>
                                <span>审批进度</span>
                                <span v-if="approvalCreateTime" class="flow-create-time">创建时间：{{ approvalCreateTime }}</span>
                            </div>
                            <span v-if="approvalSteps.length" class="flow-count">{{ approvalSteps.length }} 人</span>
                        </div>
                        <div v-if="approvalSteps.length > 0" class="approval-steps-grid">
                            <div v-for="step in approvalSteps" :key="step.Id" class="approval-step-card"
                                :class="['step-tone-' + (((step.StepNumber || 1) - 1) % 4), 'is-' + (step.Status || 'Pending')]">
                                <div class="step-card-head">
                                    <div class="step-card-main">
                                        <span class="step-badge">步骤 {{ step.StepNumber }}</span>
                                        <span class="step-name">{{ step.ApproverName || '-' }}</span>
                                    </div>
                                    <el-tag size="mini" :type="getApprovalStepStatusType(step.Status)" effect="plain">
                                        {{ getApprovalStepStatusText(step.Status) }}
                                    </el-tag>
                                </div>
                                <div class="step-card-time">审批时间：{{ formatLeaveDateTimeFull(step.ApprovedAt) }}</div>
                                <div v-if="step.Comments" class="step-card-comment">审批意见：{{ step.Comments }}</div>
                            </div>
                        </div>
                        <div v-else class="no-data no-data-compact">暂无审批流程记录</div>
                    </div>
                    <div class="flow-panel">
                        <div class="flow-panel-head">
                            <div class="flow-panel-title">
                                <i class="el-icon-message"></i>
                                <span>抄送与通知</span>
                                <el-tag v-if="ccFromCurrentConfig" size="mini" type="warning" effect="plain">当前配置 · 仅供参考</el-tag>
                                <el-tag v-else size="mini" type="success" effect="plain">提交快照</el-tag>
                            </div>
                            <span v-if="ccPersonList.length" class="flow-count">{{ ccPersonList.length }} 人</span>
                        </div>
                        <div class="cc-panel-block">
                            <div class="cc-block-label">指定人员</div>
                            <div v-if="ccPersonList.length" class="cc-people">
                                <span v-for="(name, index) in ccPersonList" :key="index" class="cc-person-chip" :title="name">
                                    <i class="el-icon-user"></i>{{ name }}
                                </span>
                            </div>
                            <div v-else class="cc-empty">未指定抄送人员</div>
                        </div>
                        <div class="cc-flags">
                            <div class="cc-flag" :class="ccClassTeacher ? 'is-on' : 'is-off'">
                                <span class="cc-flag-dot"></span>
                                <div class="cc-flag-text">
                                    <div class="cc-flag-name">抄送班主任</div>
                                    <div class="cc-flag-val">{{ ccClassTeacher ? '已开启' : '未开启' }}</div>
                                </div>
                            </div>
                            <div class="cc-flag" :class="notifyParent ? 'is-on' : 'is-off'">
                                <span class="cc-flag-dot"></span>
                                <div class="cc-flag-text">
                                    <div class="cc-flag-name">通知家长</div>
                                    <div class="cc-flag-val">{{ notifyParent ? '已开启' : '未开启' }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-if="ccFromCurrentConfig" class="cc-note">
                            无提交快照时，以上按学生当前匹配的流程配置展示，仅供参考
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="leaveDetailVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 汇总下钻明细：与汇总口径一致（已同意），弹窗内可搜姓名/订单号。创建于 2026-10-26 -->
        <el-dialog :title="summaryDetailTitle" :visible.sync="summaryDetailVisible" width="980px"
            custom-class="lmr-summary-detail-dialog" @closed="resetSummaryDetail">
            <div class="lmr-summary-detail-body">
                <el-form :inline="true" size="small" class="lmr-summary-detail-filters" @submit.native.prevent>
                    <el-form-item label="姓名">
                        <el-input v-model="summaryDetailFilters.name" placeholder="学生姓名" clearable style="width: 140px"
                            @keyup.enter.native="searchSummaryDetail"></el-input>
                    </el-form-item>
                    <el-form-item label="订单号">
                        <el-input v-model="summaryDetailFilters.orderNo" placeholder="订单号" clearable style="width: 180px"
                            @keyup.enter.native="searchSummaryDetail"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="searchSummaryDetail">查询</el-button>
                    </el-form-item>
                </el-form>
                <div class="lmr-summary-detail-tip">仅展示汇总口径：请假已通过且退餐已同意</div>
                <div class="lmr-summary-detail-table-wrap">
                    <el-table :data="summaryDetailList" v-loading="summaryDetailLoading" border size="small"
                        height="420" style="width: 100%">
                        <el-table-column type="index" label="序号" width="55" align="center"
                            :index="summaryDetailIndexMethod"></el-table-column>
                        <el-table-column label="学生信息" min-width="120" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="lmr-primary-text">{{ scope.row.UserName }}</div>
                                <div class="lmr-sub-text">{{ scope.row.DepartmentName }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="退餐项目" min-width="120">
                            <template slot-scope="scope">
                                <div class="lmr-primary-text">{{ scope.row.MealDate }}</div>
                                <div class="lmr-sub-text">{{ scope.row.WeekDayName }} · {{ scope.row.DinnerName }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单号" min-width="140">
                            <template slot-scope="scope">
                                <div class="lmr-order-no" :title="scope.row.OrderNo || ''">
                                    <div class="lmr-primary-text">{{ orderNoLines(scope.row.OrderNo).first }}</div>
                                    <div v-if="orderNoLines(scope.row.OrderNo).second" class="lmr-sub-text">{{ orderNoLines(scope.row.OrderNo).second }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="请假信息" min-width="220">
                            <template slot-scope="scope">
                                <div class="lmr-leave-block"
                                    :title="'查看' + (scope.row.RequestTypeName || '请假') + '详情'"
                                    @click.stop="openLeaveDetail(scope.row)">
                                    <div class="lmr-status-line">
                                        <span class="lmr-status-label">类型</span>
                                        <span class="lmr-status-value">
                                            <span class="lmr-leave-link">{{ scope.row.RequestTypeName || '-' }}</span>
                                            <span> · {{ scope.row.LeaveTypeName || '-' }}</span>
                                        </span>
                                    </div>
                                    <div class="lmr-status-line">
                                        <span class="lmr-status-label">时间</span>
                                        <span class="lmr-status-value">{{ scope.row.LeaveStartDate || '-' }} ~ {{ scope.row.LeaveEndDate || '-' }}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="退餐审核" min-width="150">
                            <template slot-scope="scope">
                                <el-tag size="mini" type="success">{{ scope.row.AuditStatusName || '已同意' }}</el-tag>
                                <div class="lmr-sub-text">{{ scope.row.AuditTime || '-' }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination-container lmr-summary-detail-pager">
                    <el-pagination layout="total, sizes, prev, pager, next, jumper"
                        :current-page="summaryDetailPage" :page-size="summaryDetailPageSize"
                        :page-sizes="[20, 50, 100]" :total="summaryDetailTotal"
                        style="float: right"
                        @size-change="handleSummaryDetailSizeChange"
                        @current-change="handleSummaryDetailPageChange"></el-pagination>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="summaryDetailVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import {
    getLeaveMealRefundDetailPage,
    getLeaveMealRefundSummary,
    getLeaveMealRefundDinnerTimes,
    exportLeaveMealRefundDetail,
    exportLeaveMealRefundSummary,
    approveLeaveMealRefund,
    rejectLeaveMealRefund,
    deleteLeaveMealRefund
} from '../../api/modules/catering';
import { getLeaveRequestByDepartment, getAgentLeaveRequestByDepartment } from '../../api/modules/misc';
import DepartmentPane from '../../components/DepartmentPane';

/**
 * 日期格式化为 yyyy-MM-dd
 * @param {Date} d
 * @returns {string}
 */
function formatDate(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}

function emptySummary() {
    return { TotalPersonCount: 0, TotalMealCount: 0, ByDay: [], ByClass: [] };
}

export default {
    name: 'LeaveMealRefund',
    components: { DepartmentPane },
    data() {
        const now = new Date();
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return {
            departmentId: '',
            dateRange: [formatDate(monthStart), formatDate(now)],
            filters: { name: '', orderNo: '', dinnerTimeId: 0, requestType: '', auditStatus: '', effectiveStatus: '' },
            dinnerTimeOptions: [],
            activeTab: 'detail',
            detailList: [],
            detailLoading: false,
            selectedRows: [],
            page: 1,
            pageSize: 20,
            total: 0,
            summary: emptySummary(),
            summaryLoading: false,
            summaryMode: 'day',
            summaryPage: 1,
            summaryPageSize: 20,
            exporting: false,
            leaveDetailVisible: false,
            leaveDetailLoading: false,
            leaveDetailIsAgent: false,
            leaveDetailActiveTab: 'steps',
            approvalSteps: [],
            agentLeaveDetails: [],
            ccPersonList: [],
            ccClassTeacher: false,
            notifyParent: true,
            ccFromCurrentConfig: false,
            summaryDetailVisible: false,
            summaryDetailLoading: false,
            summaryDetailList: [],
            summaryDetailPage: 1,
            summaryDetailPageSize: 20,
            summaryDetailTotal: 0,
            summaryDetailRow: null,
            summaryDetailFilters: { name: '', orderNo: '' }
        };
    },
    computed: {
        /** 当前汇总维度的全部行 */
        summaryRows() {
            return (this.summaryMode === 'day' ? this.summary.ByDay : this.summary.ByClass) || [];
        },
        /** 汇总前端分页后的当前页行 */
        summaryPagedRows() {
            const start = (this.summaryPage - 1) * this.summaryPageSize;
            return this.summaryRows.slice(start, start + this.summaryPageSize);
        },
        /** 汇总下钻弹窗标题。创建于 2026-10-26 */
        summaryDetailTitle() {
            const row = this.summaryDetailRow;
            if (!row) return '汇总明细';
            if (this.summaryMode === 'day') {
                return `汇总明细 · ${row.MealDate || ''} ${row.WeekDayName || ''} · ${row.DinnerName || ''}`;
            }
            return `汇总明细 · ${row.DepartmentName || ''} · ${row.DinnerName || ''}`;
        },
        /** 取第一个审批节点的创建时间。创建于 2026-10-26 */
        approvalCreateTime() {
            if (!this.approvalSteps || !this.approvalSteps.length) return '';
            const first = this.approvalSteps.reduce((min, step) => {
                if (!min) return step;
                return (step.StepNumber || 0) < (min.StepNumber || 0) ? step : min;
            }, null);
            if (!first || !first.CreateTime) return '';
            return this.formatLeaveDateTimeFull(first.CreateTime);
        }
    },
    methods: {
        /**
         * 左侧部门树点击：刷新餐次下拉并重新查询。创建于 2026-10-05
         */
        treeNodeClick(data) {
            this.departmentId = data.Id;
            this.filters.dinnerTimeId = 0;
            this.loadDinnerTimes();
            this.handleSearch();
        },
        loadDinnerTimes() {
            getLeaveMealRefundDinnerTimes({ departmentId: this.departmentId }).then(res => {
                this.dinnerTimeOptions = (res.data && res.data.success && res.data.response) || [];
            });
        },
        /**
         * 组装查询参数
         * @returns {Object}
         */
        buildQuery() {
            const range = this.dateRange || [];
            return {
                departmentId: this.departmentId,
                startDate: range[0] || '',
                endDate: range[1] || '',
                name: this.filters.name,
                orderNo: this.filters.orderNo,
                dinnerTimeId: this.filters.dinnerTimeId,
                requestType: this.filters.requestType,
                auditStatus: this.filters.auditStatus,
                effectiveStatus: this.filters.effectiveStatus
            };
        },
        handleSearch() {
            if (!this.departmentId) {
                this.$message.warning('请选择部门');
                return;
            }
            this.page = 1;
            this.loadSummary();
            if (this.activeTab === 'detail') this.loadDetail();
        },
        handleTabClick() {
            if (!this.departmentId) return;
            if (this.activeTab === 'detail') this.loadDetail();
        },
        loadDetail() {
            this.detailLoading = true;
            getLeaveMealRefundDetailPage({ ...this.buildQuery(), page: this.page, pageSize: this.pageSize }).then(res => {
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    this.detailList = resp.data || [];
                    this.total = resp.dataCount || 0;
                } else {
                    this.$message.error((res.data && res.data.msg) || '获取明细失败');
                }
            }).catch(() => {
                this.$message.error('获取明细出错');
            }).finally(() => {
                this.detailLoading = false;
            });
        },
        handleSelectionChange(rows) {
            this.selectedRows = rows || [];
        },
        handleRowClick(row, column, event) {
            if (event && event.target && (
                event.target.closest('button')
                || event.target.closest('.lmr-leave-block')
            )) return;
            if (this.$refs.detailTable) {
                this.$refs.detailTable.toggleRowSelection(row);
            }
        },
        /**
         * 打开关联请假/代请假审批流程（样式对齐请假报表）。创建于 2026-10-26
         * @param {Object} row 退餐明细行
         */
        openLeaveDetail(row) {
            if (!row || !row.RequestId) {
                this.$message.warning('缺少请假单据，无法查看详情');
                return;
            }
            const isAgent = row.RequestType === 'agent_leave';
            const api = isAgent ? getAgentLeaveRequestByDepartment : getLeaveRequestByDepartment;
            this.leaveDetailIsAgent = isAgent;
            this.leaveDetailActiveTab = 'steps';
            this.approvalSteps = [];
            this.agentLeaveDetails = [];
            this.ccPersonList = [];
            this.ccClassTeacher = false;
            this.notifyParent = true;
            this.ccFromCurrentConfig = false;
            this.leaveDetailVisible = true;
            this.leaveDetailLoading = true;
            api({ id: row.RequestId, page: 1, intPageSize: 1 }).then(res => {
                if (!(res.data && res.data.success)) {
                    this.$message.error((res.data && res.data.msg) || '获取请假详情失败');
                    return;
                }
                const list = (res.data.response && res.data.response.data) || [];
                const detail = list[0];
                if (!detail) {
                    this.$message.warning('未找到对应请假单据');
                    return;
                }
                this.approvalSteps = detail.LeaveApprovalSteps || [];
                this.ccPersonList = this.parseCcPersonNames(detail.CcPersonNames);
                this.ccClassTeacher = !!detail.CcClassTeacher;
                this.notifyParent = detail.NotifyParent !== false;
                this.ccFromCurrentConfig = !!detail.CcFromCurrentConfig;
                if (isAgent) {
                    this.agentLeaveDetails = detail.Details || [];
                }
            }).catch(() => {
                this.$message.error('获取请假详情出错');
            }).finally(() => {
                this.leaveDetailLoading = false;
            });
        },
        resetLeaveDetail() {
            this.leaveDetailLoading = false;
            this.leaveDetailIsAgent = false;
            this.leaveDetailActiveTab = 'steps';
            this.approvalSteps = [];
            this.agentLeaveDetails = [];
            this.ccPersonList = [];
            this.ccClassTeacher = false;
            this.notifyParent = true;
            this.ccFromCurrentConfig = false;
        },
        parseCcPersonNames(val) {
            if (!val) return [];
            return String(val).split('|').map(s => s.trim()).filter(s => s);
        },
        getApprovalStepStatusType(status) {
            return {
                Pending: 'warning',
                Approved: 'success',
                Rejected: 'danger',
                Cancel: 'info'
            }[status] || 'info';
        },
        getApprovalStepStatusText(status) {
            return {
                Pending: '待审批',
                Approved: '已批准',
                Rejected: '已拒绝',
                Cancel: '已取消'
            }[status] || '未知状态';
        },
        formatLeaveDay(val) {
            if (!val || String(val).startsWith('0001')) return '-';
            const d = new Date(val);
            if (Number.isNaN(d.getTime())) {
                const text = String(val);
                return text.length >= 10 ? text.slice(0, 10) : text;
            }
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        },
        formatLeaveDateTimeFull(val) {
            if (!val || String(val).startsWith('0001')) return '-';
            const d = new Date(val);
            if (Number.isNaN(d.getTime())) {
                const text = String(val).replace('T', ' ');
                return text.length >= 19 ? text.slice(0, 19) : text;
            }
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const hh = String(d.getHours()).padStart(2, '0');
            const mm = String(d.getMinutes()).padStart(2, '0');
            const ss = String(d.getSeconds()).padStart(2, '0');
            return `${y}-${m}-${day} ${hh}:${mm}:${ss}`;
        },
        /**
         * 订单号拆成两行：优先按最后一个「-」分段，否则按中点拆。创建于 2026-10-26
         * @param {string} orderNo
         * @returns {{ first: string, second: string }}
         */
        orderNoLines(orderNo) {
            const text = (orderNo || '').trim();
            if (!text) return { first: '-', second: '' };
            if (text.length <= 12) return { first: text, second: '' };
            const idx = text.lastIndexOf('-');
            if (idx > 0 && idx < text.length - 1) {
                return { first: text.slice(0, idx + 1), second: text.slice(idx + 1) };
            }
            const mid = Math.ceil(text.length / 2);
            return { first: text.slice(0, mid), second: text.slice(mid) };
        },
        canAudit(row) {
            return row && Number(row.EffectiveStatus) === 1 && Number(row.AuditStatus) === 0;
        },
        auditStatusLabel(row) {
            if (Number(row.EffectiveStatus) === 2) return '不可审核';
            return row.AuditStatusName || ['待审核', '已同意', '已拒绝'][Number(row.AuditStatus)] || '待审核';
        },
        auditTagType(row) {
            if (Number(row.EffectiveStatus) === 2) return 'info';
            return Number(row.AuditStatus) === 1 ? 'success' : Number(row.AuditStatus) === 2 ? 'danger' : 'warning';
        },
        leaveStatusLabel(row) {
            return ['审批中', '已通过', '已失效'][Number(row.EffectiveStatus)] || '未知';
        },
        leaveStatusTagType(row) {
            const status = Number(row.EffectiveStatus);
            return status === 1 ? 'success' : status === 2 ? 'info' : 'warning';
        },
        approveRows(rows) {
            const ids = (rows || []).filter(row => this.canAudit(row)).map(row => row.Id);
            if (!ids.length) {
                this.$message.warning('没有可同意的记录');
                return;
            }
            this.$confirm(`确定同意选中的 ${ids.length} 条退餐记录吗？`, '提示', { type: 'warning' }).then(() => {
                return approveLeaveMealRefund({ ids });
            }).then(res => {
                if (res.data && res.data.success) {
                    this.$message.success(res.data.msg || '同意成功');
                    this.loadDetail();
                    this.loadSummary();
                } else {
                    this.$message.error((res.data && res.data.msg) || '同意失败');
                }
            }).catch(err => {
                if (err === 'cancel' || err === 'close') return;
                const response = err && err.response && err.response.data;
                this.$message.error((response && response.msg) || '同意请求失败，请检查后台接口是否已更新');
            });
        },
        openReject(rows) {
            const ids = (rows || []).filter(row => this.canAudit(row)).map(row => row.Id);
            if (!ids.length) {
                this.$message.warning('没有可拒绝的记录');
                return;
            }
            this.$prompt('请输入拒绝原因', '拒绝退餐', {
                inputType: 'textarea',
                inputValidator: value => value && value.trim() ? true : '拒绝原因不能为空',
                inputErrorMessage: '拒绝原因不能为空'
            }).then(({ value }) => rejectLeaveMealRefund({ ids, reason: value })).then(res => {
                if (res.data && res.data.success) {
                    this.$message.success(res.data.msg || '拒绝成功');
                    this.loadDetail();
                    this.loadSummary();
                } else {
                    this.$message.error((res.data && res.data.msg) || '拒绝失败');
                }
            }).catch(err => {
                if (err === 'cancel' || err === 'close') return;
                const response = err && err.response && err.response.data;
                this.$message.error((response && response.msg) || '拒绝请求失败，请检查后台接口是否已更新');
            });
        },
        /**
         * 删除退餐登记（含失效/已审记录，仅清理登记数据）。创建于 2026-10-27
         */
        deleteRows(rows) {
            const ids = (rows || []).map(row => row.Id).filter(id => id > 0);
            if (!ids.length) {
                this.$message.warning('请选择要删除的记录');
                return;
            }
            this.$confirm(`确定删除选中的 ${ids.length} 条退餐登记吗？删除后不可恢复。`, '删除退餐登记', {
                type: 'warning',
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => deleteLeaveMealRefund({ ids })).then(res => {
                if (res.data && res.data.success) {
                    this.$message.success(res.data.msg || '删除成功');
                    this.loadDetail();
                    this.loadSummary();
                } else {
                    this.$message.error((res.data && res.data.msg) || '删除失败');
                }
            }).catch(err => {
                if (err === 'cancel' || err === 'close') return;
                const response = err && err.response && err.response.data;
                this.$message.error((response && response.msg) || '删除请求失败');
            });
        },
        /**
         * 打开汇总行下钻明细弹窗。创建于 2026-10-26
         * @param {Object} row 汇总行
         */
        openSummaryDetail(row) {
            if (!row) return;
            this.summaryDetailRow = row;
            this.summaryDetailFilters = {
                name: this.filters.name || '',
                orderNo: this.filters.orderNo || ''
            };
            this.summaryDetailPage = 1;
            this.summaryDetailVisible = true;
            this.loadSummaryDetail();
        },
        searchSummaryDetail() {
            this.summaryDetailPage = 1;
            this.loadSummaryDetail();
        },
        handleSummaryDetailPageChange(val) {
            this.summaryDetailPage = val;
            this.loadSummaryDetail();
        },
        handleSummaryDetailSizeChange(val) {
            this.summaryDetailPageSize = val;
            this.summaryDetailPage = 1;
            this.loadSummaryDetail();
        },
        summaryDetailIndexMethod(index) {
            return (this.summaryDetailPage - 1) * this.summaryDetailPageSize + index + 1;
        },
        /**
         * 组装汇总下钻查询：锁定餐次，并按日期/班级维度收窄；口径与汇总一致（已同意）。
         * @returns {Object}
         */
        buildSummaryDetailQuery() {
            const base = this.buildQuery();
            const row = this.summaryDetailRow || {};
            const query = {
                ...base,
                name: this.summaryDetailFilters.name,
                orderNo: this.summaryDetailFilters.orderNo,
                dinnerTimeId: row.DinnerTimeId || 0,
                auditStatus: 1,
                effectiveStatus: 1,
                page: this.summaryDetailPage,
                pageSize: this.summaryDetailPageSize
            };
            if (this.summaryMode === 'day' && row.MealDate) {
                query.startDate = row.MealDate;
                query.endDate = row.MealDate;
            }
            if (this.summaryMode === 'class' && row.DepartmentId) {
                query.departmentId = row.DepartmentId;
            }
            return query;
        },
        loadSummaryDetail() {
            if (!this.summaryDetailRow) return;
            this.summaryDetailLoading = true;
            getLeaveMealRefundDetailPage(this.buildSummaryDetailQuery()).then(res => {
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    this.summaryDetailList = resp.data || [];
                    this.summaryDetailTotal = resp.dataCount || 0;
                } else {
                    this.summaryDetailList = [];
                    this.summaryDetailTotal = 0;
                    this.$message.error((res.data && res.data.msg) || '获取汇总明细失败');
                }
            }).catch(() => {
                this.summaryDetailList = [];
                this.summaryDetailTotal = 0;
                this.$message.error('获取汇总明细出错');
            }).finally(() => {
                this.summaryDetailLoading = false;
            });
        },
        resetSummaryDetail() {
            this.summaryDetailLoading = false;
            this.summaryDetailList = [];
            this.summaryDetailTotal = 0;
            this.summaryDetailPage = 1;
            this.summaryDetailRow = null;
            this.summaryDetailFilters = { name: '', orderNo: '' };
        },
        loadSummary() {
            this.summaryLoading = true;
            this.summaryPage = 1;
            getLeaveMealRefundSummary(this.buildQuery()).then(res => {
                if (res.data && res.data.success) {
                    this.summary = Object.assign(emptySummary(), res.data.response || {});
                } else {
                    this.summary = emptySummary();
                    this.$message.error((res.data && res.data.msg) || '获取汇总失败');
                }
            }).catch(() => {
                this.summary = emptySummary();
                this.$message.error('获取汇总出错');
            }).finally(() => {
                this.summaryLoading = false;
            });
        },
        handleCurrentChange(val) {
            this.page = val;
            this.loadDetail();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.page = 1;
            this.loadDetail();
        },
        indexMethod(index) {
            return (this.page - 1) * this.pageSize + index + 1;
        },
        /**
         * 汇总表合计行：人数取整体去重人数，次数取整体去重次数
         */
        summaryMethod({ columns }) {
            return columns.map((col, idx) => {
                if (idx === 0) return '合计';
                if (col.property === 'PersonCount') return this.summary.TotalPersonCount;
                if (col.property === 'MealCount') return this.summary.TotalMealCount;
                return '';
            });
        },
        /**
         * 按当前页签导出明细或汇总 Excel。创建于 2026-10-05
         */
        handleExport() {
            if (!this.departmentId) {
                this.$message.warning('请选择部门');
                return;
            }
            const isDetail = this.activeTab === 'detail';
            const query = this.buildQuery();
            const api = isDetail ? exportLeaveMealRefundDetail : exportLeaveMealRefundSummary;
            this.exporting = true;
            api(query).then(res => {
                const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.download = `请假退餐${isDetail ? '明细' : '汇总'}_${query.startDate}_${query.endDate}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(href);
                this.$message.success('导出成功');
            }).catch(async err => {
                let msg = '导出失败';
                const data = err && err.response && err.response.data;
                if (data instanceof Blob) {
                    try { msg = (await data.text()) || msg; } catch (e) { /* 忽略 */ }
                }
                this.$message.error(msg);
            }).finally(() => {
                this.exporting = false;
            });
        }
    }
};
</script>

<style scoped>
.lmr-notice,
.lmr-filters {
    flex-shrink: 0;
}

.lmr-notice {
    margin-bottom: 10px;
    padding: 6px 12px;
}

.lmr-filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.lmr-filters .el-form-item {
    margin-bottom: 8px;
}

.dp-right > .el-form.lmr-filters .el-form-item .el-button + .el-button {
    margin-left: 8px !important;
}

.lmr-stats {
    margin: 0 0 8px auto;
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
}

.lmr-stats b {
    margin-left: 4px;
    font-size: 16px;
    color: #303133;
}

.lmr-stats-sep {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 12px;
    background: #dcdfe6;
    vertical-align: middle;
}

.lmr-summary-bar {
    flex-shrink: 0;
    margin-bottom: 8px;
}

.lmr-batch-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    height: 38px;
    padding: 0 0 8px 12px;
    background: #fff;
}

.lmr-tabs-wrap {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    position: relative;
}

.lmr-tabs-wrap > .el-tabs {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
}

.lmr-tabs-wrap > .el-tabs /deep/ .el-tabs__content {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
}

.lmr-tabs-wrap /deep/ .el-tab-pane {
    display: flex;
    height: 100%;
    min-height: 0;
    flex-direction: column;
}

.lmr-tabs-wrap /deep/ .tbl-scroll-host {
    flex: 1;
    min-height: 0;
}

.lmr-selected-count {
    margin-right: 4px;
    color: #909399;
    font-size: 12px;
}

.lmr-sub-text {
    display: block;
    margin-top: 4px;
    color: #9aa3b2;
    font-size: 12px;
    line-height: 16px;
}

.lmr-primary-text {
    overflow: hidden;
    color: #303133;
    font-size: 13px;
    font-weight: 600;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.lmr-order-no .lmr-primary-text {
    font-weight: 500;
    letter-spacing: 0.2px;
}

.lmr-order-no .lmr-sub-text {
    margin-top: 2px;
    color: #606266;
    font-family: Consolas, Monaco, 'Courier New', monospace;
    font-size: 12px;
    letter-spacing: 0.3px;
}

.lmr-status-line {
    display: flex;
    align-items: center;
    min-height: 21px;
    overflow: hidden;
    gap: 4px;
    white-space: nowrap;
}

.lmr-status-label {
    display: inline-block;
    width: 34px;
    flex: 0 0 34px;
    color: #98a1af;
    font-size: 12px;
}

.lmr-status-value {
    overflow: hidden;
    color: #606266;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.lmr-audit-status-label {
    width: 54px;
    flex-basis: 54px;
}

.lmr-status-summary {
    margin-top: 3px;
    padding-top: 3px;
    border-top: 1px solid #f0f2f5;
}

.lmr-audit-label {
    margin-left: 10px;
}

.lmr-result-text {
    min-height: 19px;
    color: #909399;
    font-size: 11px;
}

.lmr-inline-sub {
    display: inline-block;
    margin-left: 6px;
    color: #909399;
    font-size: 12px;
    vertical-align: middle;
}

.lmr-page /deep/ .el-table .cell {
    line-height: 20px;
}

.lmr-page /deep/ .el-table td {
    padding-top: 9px;
    padding-bottom: 9px;
}

.lmr-page /deep/ .el-table th {
    color: #606266;
    font-weight: 600;
    background: #f7f9fc;
}

.lmr-page /deep/ .el-tag {
    border-radius: 4px;
}

.lmr-summary-link {
    color: #409eff;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
}

.lmr-summary-link:hover {
    text-decoration: underline;
}

.lmr-summary-detail-body {
    display: flex;
    flex-direction: column;
    min-height: 520px;
}

.lmr-summary-detail-filters {
    flex-shrink: 0;
    margin-bottom: 4px;
}

.lmr-summary-detail-filters .el-form-item {
    margin-bottom: 8px;
}

.lmr-summary-detail-tip {
    flex-shrink: 0;
    margin-bottom: 10px;
    color: #909399;
    font-size: 12px;
    line-height: 18px;
}

.lmr-summary-detail-table-wrap {
    flex: 0 0 420px;
    height: 420px;
    min-height: 420px;
}

.lmr-summary-detail-pager {
    flex-shrink: 0;
    margin-top: 12px;
    overflow: hidden;
}

.lmr-leave-block {
    margin: -4px -6px;
    padding: 4px 6px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.lmr-leave-block:hover {
    background: #f0f7ff;
}

.lmr-leave-block:hover .lmr-leave-link {
    text-decoration: underline;
}

.lmr-leave-link {
    color: #409eff;
}

/* 审批流程弹窗：与请假报表统一面板样式。创建于 2026-10-26 */
.flow-panel {
    margin-bottom: 12px;
    padding: 14px 16px 12px;
    border: 1px solid #dbe4f0;
    border-radius: 10px;
    background: linear-gradient(180deg, #f8fbff 0%, #f4f7fb 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.flow-panel:last-of-type {
    margin-bottom: 0;
}

.flow-panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #d7e2ef;
}

.flow-panel-title {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #1e3a5f;
}

.flow-panel-title i {
    width: 26px;
    height: 26px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(37, 99, 235, 0.12);
    color: var(--btn-primary, #2563eb);
    font-size: 14px;
}

.flow-create-time {
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
}

.flow-count {
    flex-shrink: 0;
    padding: 1px 8px;
    border-radius: 999px;
    background: #eff6ff;
    color: #2563eb;
    font-size: 11px;
    font-weight: 600;
}

.approval-steps-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    max-height: 320px;
    overflow-y: auto;
}

.approval-step-card {
    flex: 0 0 calc(50% - 6px);
    box-sizing: border-box;
    min-width: 0;
    padding: 12px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #fff;
}

.approval-step-card.step-tone-0 {
    border-color: #bfdbfe;
    background: #f8fbff;
}

.approval-step-card.step-tone-0 .step-badge {
    background: #2563eb;
}

.approval-step-card.step-tone-1 {
    border-color: #ddd6fe;
    background: #faf8ff;
}

.approval-step-card.step-tone-1 .step-badge {
    background: #7c3aed;
}

.approval-step-card.step-tone-2 {
    border-color: #99f6e4;
    background: #f0fdfa;
}

.approval-step-card.step-tone-2 .step-badge {
    background: #0d9488;
}

.approval-step-card.step-tone-3 {
    border-color: #fed7aa;
    background: #fff7ed;
}

.approval-step-card.step-tone-3 .step-badge {
    background: #ea580c;
}

.step-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
}

.step-card-main {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.step-badge {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 999px;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
}

.step-name {
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.step-card-time {
    font-size: 12px;
    color: #64748b;
    line-height: 1.4;
}

.step-card-comment {
    margin-top: 6px;
    padding-left: 8px;
    border-left: 2px solid #93c5fd;
    max-height: 72px;
    overflow-y: auto;
    font-size: 12px;
    color: #1e3a5f;
    line-height: 1.45;
    word-break: break-word;
    overflow-wrap: anywhere;
}

.cc-panel-block {
    margin-bottom: 12px;
}

.cc-block-label {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
}

.cc-people {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 180px;
    overflow-y: auto;
    padding: 8px 10px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #fff;
}

.cc-person-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 160px;
    padding: 4px 10px;
    border-radius: 999px;
    background: #f8fafc;
    border: 1px solid #c7d7f0;
    color: #1d4ed8;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cc-person-chip i {
    flex-shrink: 0;
    font-size: 12px;
    color: #3b82f6;
}

.cc-empty {
    font-size: 13px;
    color: #94a3b8;
}

.cc-flags {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.cc-flag {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid transparent;
    background: #fff;
}

.cc-flag.is-on {
    border-color: #bbf7d0;
    background: #f0fdf4;
}

.cc-flag.is-off {
    border-color: #e2e8f0;
    background: #f8fafc;
}

.cc-flag-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}

.cc-flag.is-on .cc-flag-dot {
    background: #22c55e;
    box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15);
}

.cc-flag.is-off .cc-flag-dot {
    background: #94a3b8;
    box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.cc-flag-name {
    font-size: 12px;
    color: #64748b;
    line-height: 1.2;
}

.cc-flag-val {
    margin-top: 2px;
    font-size: 13px;
    font-weight: 600;
    color: #0f172a;
    line-height: 1.2;
}

.cc-flag.is-off .cc-flag-val {
    color: #64748b;
    font-weight: 500;
}

.cc-note {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #d7e2ef;
    color: #94a3b8;
    font-size: 12px;
    line-height: 1.5;
}

.no-data {
    text-align: center;
    color: #999;
    padding: 40px 0;
}

.no-data-compact {
    padding: 18px 0 12px;
}
</style>

